import React, { useEffect } from "react";
import { SyncAvatarIndicator } from "@/components/sync/sync-avatar-indicator";
import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { buildProxiedAssetUrl } from "@/modules/asset-proxy";
import { MDSUserAvatar, MDSUserAvatarProps } from "@/mds/components/user-avatar";

interface AccountProfileImageContentProps extends MDSUserAvatarProps {
  showSyncStatus?: boolean;
}

export const AccountProfileImage: React.FC<AccountProfileImageContentProps> = observer(
  ({ size, photoUrl, displayName, showSyncStatus = false }) => {
    const { store } = useAppStore();
    const assetAccessTokenState = store.auth.assetAccessTokenState;

    useEffect(() => {
      if (!photoUrl || assetAccessTokenState?.token) {
        return;
      }

      if (!assetAccessTokenState) {
        return;
      }

      void assetAccessTokenState.ensureToken();
    }, [assetAccessTokenState, photoUrl]);

    const proxiedPhotoUrl = buildProxiedAssetUrl({
      originalUrl: photoUrl,
      assetAccessTokenState,
    });

    return showSyncStatus ? (
      <SyncAvatarIndicator syncState={store.sync.syncState}>
        <MDSUserAvatar photoUrl={proxiedPhotoUrl} displayName={displayName} size={size} />
      </SyncAvatarIndicator>
    ) : (
      <MDSUserAvatar photoUrl={proxiedPhotoUrl} displayName={displayName} size={size} />
    );
  }
);
